import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BillingRoutingModule } from '@billing/billing-routing.module'
import { SharedModule } from '@shared/shared.module'

import { CreateOrganizationComponent } from './create-organization/create-organization.component'
import { EditAddOnsComponent } from './edit-add-ons/edit-add-ons.component'
import { EditSubscriptionComponent } from './edit-subscription/edit-subscription.component'
import { MainComponent } from './main/main.component'
import { RightPanelComponent } from './right-panel/right-panel.component'
import { SelectTierComponent } from './select-tier/select-tier.component'
import { UpgradeTierComponent } from './upgrade-tier/upgrade-tier.component'
import { ViewInvoiceComponent } from './view-invoice/view-invoice.component'

@NgModule({
  declarations: [
    CreateOrganizationComponent,
    EditAddOnsComponent,
    EditSubscriptionComponent,
    MainComponent,
    RightPanelComponent,
    SelectTierComponent,
    UpgradeTierComponent,
    ViewInvoiceComponent,
  ],
  imports: [
    BillingRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [
    CreateOrganizationComponent,
    SelectTierComponent,
    ViewInvoiceComponent,
  ]
})
export class BillingModule { }